export const LIVESTREAM_REVIEW_STATUS = {
  PENDING_REVIEW: 'pending_review',
  CLARIFICATION_REQUESTED: 'clarification_requested',
  CREATOR_RESPONDED: 'creator_responded',
  APPROVED: 'approved',
};

export const MAX_CLARIFICATION_REQUESTS = 2;
export const MAX_CLARIFICATION_MESSAGE_LENGTH = 500;
export const MAX_LIVESTREAM_PROOF_FILES = 3;

export const CLARIFICATION_REASONS = [
  { value: 'missing_livestream_proof', label: 'Missing livestream proof' },
  { value: 'sales_count_mismatch', label: 'Sales count mismatch' },
  { value: 'hours_worked_incorrect', label: 'Hours worked is wrong' },
  { value: 'replay_link_not_working', label: 'Replay link not working' },
  { value: 'required_disclosure_missing', label: 'Required disclosure missing' },
  { value: 'wrong_product_shown', label: 'Wrong product shown' },
  { value: 'other', label: 'Other' },
];

export const getClarificationReasonLabel = (value) => (
  CLARIFICATION_REASONS.find((r) => r.value === value)?.label || value
);

export const getLivestreamProofFilenames = (deliverable) => {
  const raw = deliverable?.proof_urls;
  if (!Array.isArray(raw)) return [];
  return raw.map((value) => String(value).trim()).filter(Boolean);
};

export const isLivestreamProofPdf = (filename) => /\.pdf$/i.test(String(filename || ''));

export const formatHoursWorked = (value) => {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return String(n);
};

export const getLivestreamReviewStatus = (collaboration) => {
  const deliverable = collaboration?.deliverable;
  if (!deliverable || deliverable.type !== 'livestream') return null;
  if (deliverable.status === 'approved') return LIVESTREAM_REVIEW_STATUS.APPROVED;
  return deliverable.livestream_review_status || LIVESTREAM_REVIEW_STATUS.PENDING_REVIEW;
};

export const getClarificationRequestCount = (collaboration) => (
  collaboration?.deliverable?.clarification_request_count || 0
);

export const canRequestLivestreamClarification = (collaboration) => {
  const deliverable = collaboration?.deliverable;
  if (!deliverable || deliverable.type !== 'livestream') return false;
  if (deliverable.status !== 'completed') return false;
  const reviewStatus = getLivestreamReviewStatus(collaboration);
  if (reviewStatus === LIVESTREAM_REVIEW_STATUS.CLARIFICATION_REQUESTED) return false;
  if (reviewStatus === LIVESTREAM_REVIEW_STATUS.APPROVED) return false;
  return getClarificationRequestCount(collaboration) < MAX_CLARIFICATION_REQUESTS;
};

export const canApproveLivestream = (collaboration) => {
  const deliverable = collaboration?.deliverable;
  if (!deliverable || deliverable.type !== 'livestream') return false;
  if (deliverable.status !== 'completed') return false;
  const reviewStatus = getLivestreamReviewStatus(collaboration);
  return reviewStatus !== LIVESTREAM_REVIEW_STATUS.CLARIFICATION_REQUESTED
    && reviewStatus !== LIVESTREAM_REVIEW_STATUS.APPROVED;
};

export const needsLivestreamClarificationResponse = (collaboration) => (
  getLivestreamReviewStatus(collaboration) === LIVESTREAM_REVIEW_STATUS.CLARIFICATION_REQUESTED
);

export const isLivestreamAwaitingBrandReviewAfterResponse = (collaboration) => {
  const reviewStatus = getLivestreamReviewStatus(collaboration);
  return reviewStatus === LIVESTREAM_REVIEW_STATUS.CREATOR_RESPONDED
    || reviewStatus === LIVESTREAM_REVIEW_STATUS.PENDING_REVIEW;
};
